module.exports = __webpack_public_path__ + "img/18-583566.png";